import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CheckDto } from "src/app/shared/models/check-dto";
import { CustomerSubscriptionItem } from "src/app/shared/models/CustomerSubscription.item";

@Component({
	selector: "app-customer-subscription-record-history",
	templateUrl: "./customer-subscription-record-history.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class CustomerSubscriptionRecordHistoryComponent implements OnInit {
	@Input() subscriptionItem: CustomerSubscriptionItem;
	@Output() subscriptionItemChange = new EventEmitter<CustomerSubscriptionItem>();
	@Input() checkRecordSelected: CheckDto;
	@Output() checkRecordSelectedChange = new EventEmitter<CheckDto>();

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}
}
